import React from 'react';

//material ui
import { PrimaryButton } from '../../materialUiComponents';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';

const LoginFormContentWCS = ({
  classes,
  handleWcsRegister,
  handleWscLogin,
}) => {
  return (
    <div className={classes.wcs}>
      <PrimaryButton
        style={{
          width: '100%',
          fontSize: '0.9rem',
          margin: '8px auto',
          padding: '0.5rem 0.3rem',
          textTransform: 'unset',
          borderRadius: '0.75rem',
          backgroundColor: '#BB0973',
        }}
        onClick={handleWscLogin}
        id='wcsLogin'
      >
        Sign in with the Weaviate Cloud Services
      </PrimaryButton>
      <Grid
        container
        style={{
          marginTop: '5px',
        }}
      >
        <Grid item xs>
          <Link
            className={classes.links}
            href='https://www.weaviate.io'
            target='_blank'
            rel='noreferrer'
          >
            Learn more
          </Link>
        </Grid>
        <Grid item>
          <span>Don't have an account? </span>
          <Link
            className={classes.links}
            id='registrationButton'
            onClick={handleWcsRegister}
          >
            {'Register here'}
          </Link>
        </Grid>
      </Grid>
    </div>
  );
};

export default LoginFormContentWCS;
